import { useVehiclesQuery } from "@evr/apis/vehicle";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectVehiclesQuery } from "@evr/store/slices/vehicle";

export const useGetVehiclesQuery = () => {
  const queryParams = useAppSelector(selectVehiclesQuery);
  return useVehiclesQuery(queryParams);
};
